<style scoped lang="sass">
#stats
  display: flex
  flex-direction: column
  padding: 0.7rem
  height: 100%
  box-sizing: border-box
  background-color: white
  overflow: scroll
</style>
<template>
  <right-side-tray @close="$emit('close')">
    <div id="stats" v-if="stats">
      <h4>Most Chosen Players</h4>
      <pinhigh-table
        :headers="['Player', '# of picks']"
        :rows="stats.pick_frequency"
        :justified="true"
        v-if="stats">
      </pinhigh-table>
    </div>
  </right-side-tray>
</template>
<script>
import Vuex from 'vuex'

import RightSideTray from './right-side-tray.vue'

export default {
  name: 'StatsTray',
  components: {
    RightSideTray
  },
  created() {
    this.clearStats()
    this.loadStats(this.$route.params.id)
  },
  computed: {
    ...Vuex.mapGetters('poolStats', ['stats'])
  },
  methods: {
    ...Vuex.mapActions('poolStats', ['clearStats', 'loadStats'])
  }
}
</script>
